import {
  userInfoResponse,
  userRoleResponse,
} from "@/models/equip-api-response-objects/userInfoResponse";
import { EquipConfig, localConfig, prdConfig } from "./auth/equipConfig";

export class EquipOptions {
  public CalculationMode: string = "DIRECT";
  public Online: boolean = true;
  public EquipUrl: string = "";
  public UserRoles: userRoleResponse | undefined;
  public UserDetails: userInfoResponse | undefined;
}

export const equipOptionsInstance = new EquipOptions();
